import { utilService } from '../../shared/services/UtilService';

export class ConversationModel {
    private messageGroups: MessageGroupModel[];
    constructor() {
        this.messageGroups = [];
    }

    public addMessage(message: MessageModel) {
        // Messages grouped per author. Whenever an other auhtor starts saying something, a new group is created.
        const lastMessageGroup = this.messageGroups.slice(-1).shift();
        if (lastMessageGroup && lastMessageGroup.canAddMessage(message)) {
            lastMessageGroup.addMessage(message);
        } else {
            this.messageGroups.push(new MessageGroupModel(message));
        }
    }

    public getMessageGroups() {
        return this.messageGroups.slice();
    }
}

export class MessageGroupModel {
    public id: string;
    private messages: MessageModel[];
    constructor(message?: MessageModel) {
        this.id = utilService.generateGuid();
        this.messages = [];
        if (message) {
            this.messages.push(message);
        }
    }

    public getMessages() {
        return this.messages.slice();
    }

    public canAddMessage(message: MessageModel) {
        return this.messages.every(m => m.author === message.author);
    }

    public addMessage(message: MessageModel) {
        if (this.canAddMessage(message)) {
            this.messages.push(message);
            return true;
        }
        return false;
    }

    public getAuthorType() {
        if (this.messages.length === 0) {
            return AuthorType.None;
        }
        return this.messages[0].author;
    }
}

export abstract class MessageModel {
    public id: string;
    constructor(public messageType: MessageType, public author: AuthorType, public content: string) {
        this.id = utilService.generateGuid();
    }
}

export class TextMessageModel extends MessageModel {
    constructor(author: AuthorType, content: string) {
        super(MessageType.Text, author, content);
    }
}

export class ActionsMessageModel extends MessageModel {
    constructor(author: AuthorType, content: string, public actions: MessageAction[]) {
        super(MessageType.Actions, author, content);
    }
}

export class MessageAction {
    constructor(public actionName: string, public actionFunction: Function) {}
}

export enum AuthorType {
    None,
    Joey,
    User
}

export enum MessageType {
    Text,
    Actions
}
